export function searchKey(value: string): string {
  return value.normalize('NFKC').trim().toLocaleLowerCase()
}
